module.exports = __webpack_public_path__ + "static/img/thumbs-up-down.a8be454f.svg";